module.exports = __webpack_public_path__ + "img/SW125_MemoryShare_Final-12.12ae06a7.png";